export default __webpack_public_path__ + "static/media/algodao_v3.c3f4ad2a.png";